import { render, staticRenderFns } from "./styleTest.vue?vue&type=template&id=8387508c&scoped=true&"
import script from "./styleTest.vue?vue&type=script&lang=js&"
export * from "./styleTest.vue?vue&type=script&lang=js&"
import style0 from "./styleTest.vue?vue&type=style&index=0&id=8387508c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8387508c",
  null
  
)

export default component.exports